/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createRightmoveFee = /* GraphQL */ `
  mutation CreateRightmoveFee(
    $input: CreateRightmoveFeeInput!
    $condition: ModelRightmoveFeeConditionInput
  ) {
    createRightmoveFee(input: $input, condition: $condition) {
      id
      feeType
      startDate
      endDate
      amount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateRightmoveFee = /* GraphQL */ `
  mutation UpdateRightmoveFee(
    $input: UpdateRightmoveFeeInput!
    $condition: ModelRightmoveFeeConditionInput
  ) {
    updateRightmoveFee(input: $input, condition: $condition) {
      id
      feeType
      startDate
      endDate
      amount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteRightmoveFee = /* GraphQL */ `
  mutation DeleteRightmoveFee(
    $input: DeleteRightmoveFeeInput!
    $condition: ModelRightmoveFeeConditionInput
  ) {
    deleteRightmoveFee(input: $input, condition: $condition) {
      id
      feeType
      startDate
      endDate
      amount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createForecast = /* GraphQL */ `
  mutation CreateForecast(
    $input: CreateForecastInput!
    $condition: ModelForecastConditionInput
  ) {
    createForecast(input: $input, condition: $condition) {
      id
      feeType
      startDate
      endDate
      amount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateForecast = /* GraphQL */ `
  mutation UpdateForecast(
    $input: UpdateForecastInput!
    $condition: ModelForecastConditionInput
  ) {
    updateForecast(input: $input, condition: $condition) {
      id
      feeType
      startDate
      endDate
      amount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteForecast = /* GraphQL */ `
  mutation DeleteForecast(
    $input: DeleteForecastInput!
    $condition: ModelForecastConditionInput
  ) {
    deleteForecast(input: $input, condition: $condition) {
      id
      feeType
      startDate
      endDate
      amount
      createdAt
      updatedAt
      owner
    }
  }
`;
